const HeaderMeasure = () => {
  const links = document.querySelectorAll('.js-global-nav__item a');

  const headerToggle = document.getElementById("js-header__btn")

  if (!links || !headerToggle) return

  headerToggle.addEventListener("click",()=> {
    headerToggle.classList.toggle("menuOpen")

    if(headerToggle.classList.contains("menuOpen")) {
      dataLayer.push({
        'event': 'service_humbergerMenuOpenClick',
      });
    } else {
      dataLayer.push({
        'event': 'service_humbergerMenuCloseClick',
      });
    }
  })


  links.forEach(link => {
    link.addEventListener('click', function(event) {
      // event.preventDefault()
      const parentLi = link.closest('li');
      const gaArea = parentLi.dataset.gaArea;
      dataLayer.push({
        'event': 'service_humbergerMenuLinkClick',
        'eventArea': gaArea,
      });
    });
  });
}


export {HeaderMeasure}
